/* Type styles (typography.md §2). Sizes in rem so the browser's text size setting scales them. */
.displayXL,
.displayL,
.displayS {
  font-family: var(--font-display);
  text-transform: uppercase;
}
.displayXL {
  font-weight: 700;
  font-size: 2.125rem;
  line-height: 2.375rem;
  letter-spacing: 0.04em;
}
.displayL {
  font-weight: 700;
  font-size: 1.375rem;
  line-height: 1.625rem;
  letter-spacing: 0.06em;
}
.displayS {
  font-weight: 600;
  font-size: 0.75rem;
  line-height: 0.875rem;
  letter-spacing: 0.12em;
}
.titleL {
  font-weight: 700;
  font-size: 1.25rem;
  line-height: 1.5625rem;
}
.titleM {
  font-weight: 700;
  font-size: 1.0625rem;
  line-height: 1.375rem;
}
.body {
  font-size: 1.0625rem;
  line-height: 1.375rem;
}
.bodyS {
  font-size: 0.9375rem;
  line-height: 1.25rem;
}
.caption {
  font-weight: 500;
  font-size: 0.8125rem;
  line-height: 1rem;
}
.label {
  font-weight: 700;
  font-size: 0.75rem;
  line-height: 1rem;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}
.readoutXL,
.readoutL,
.readoutM,
.readoutS,
.micro {
  font-family: var(--font-readout);
  font-weight: 500;
  font-variant-numeric: tabular-nums;
}
.readoutXL {
  font-size: 2.125rem;
  line-height: 2.375rem;
}
.readoutL {
  font-size: 1.375rem;
  line-height: 1.625rem;
}
.readoutM {
  font-size: 1.0625rem;
  line-height: 1.375rem;
}
.readoutS {
  font-size: 0.8125rem;
  line-height: 1rem;
}
.micro {
  font-size: 0.6875rem;
  line-height: 0.8125rem;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}
.code {
  font-family: var(--font-code);
  font-size: 0.9375rem;
  line-height: 1.25rem;
}

/* Compact density (web and macOS): titles and readouts one step down at desk widths. */
@media (min-width: 900px) {
  .titleM,
  .body,
  .readoutM {
    font-size: 0.9375rem;
    line-height: 1.25rem;
  }
  .caption {
    font-size: 0.78125rem;
  }
}

/* Numerals inside a display title use the readout face (C-01: `DAY` + `06 / 10`). */
.numerals {
  font-family: var(--font-readout);
  font-variant-numeric: tabular-nums;
  letter-spacing: 0;
}

/* Visually hidden, still read by screen readers. */
.srOnly {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip-path: inset(50%);
  white-space: nowrap;
}
